<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="query.no" clearable placeholder="business.label.orderNo" @clear="refresh" @keyup.enter="refresh"/>
        <vxe-button-group style="margin-left: 2px">
          <vxe-button :loading="loading" content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
          <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        </vxe-button-group>
        <vxe-select v-model="query.dispatch.wave" :options="waves" clearable placeholder="message.waveAddOrderTip" style="margin-left: 40px"/>
        <vxe-button-group style="margin-left: 2px">
          <vxe-button content="button.addOrderToWave" icon="vxe-icon-add" status="primary" @click="addOrderToWave"/>
          <vxe-button content="button.waveStatus" icon="vxe-icon-information" status="primary" @click="showWaveStatus"/>
        </vxe-button-group>
      </template>
      <template #extra>
        <vxe-button :loading="loading" content="button.arrange" icon="vxe-icon-send" status="primary" @click="arrange"/>
        <vxe-button content="button.waveIssue" icon="vxe-icon-rotate-right" status="primary" @click="waveIssue"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column field="order.operator" title="business.label.operator" width="80"/>
        <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="300"/>
        <vxe-column field="pickupMode.name" title="business.label.shipmentMode" width="80"/>
        <vxe-column field="statistics.numberOfItem" title="business.label.numberOfItem" width="60"/>
        <vxe-column field="statistics.numberOfFcl" title="business.label.numberOfFcl" width="60"/>
        <vxe-column field="statistics.numberOfLcl" title="business.label.numberOfLcl" width="60"/>
        <vxe-column field="statistics.numberOfEach" title="business.label.numberOfEach" width="60"/>
        <vxe-column field="statistics.numberOfRefrigeration" title="business.label.numberOfRefrigeration" width="60"/>
        <vxe-column field="statistics.numberOfValuable" title="business.label.numberOfValuable" width="60"/>
        <vxe-column field="statistics.numberOfImportation" title="business.label.numberOfImportation" width="60"/>
        <vxe-column field="statistics.numberOfPsychotropic" title="business.label.numberOfPsychotropic" width="60"/>
        <vxe-column field="statistics.numberOfSpecial" title="business.label.numberOfSpecial" width="60"/>
        <vxe-column field="statistics.numberOfPeptides" title="business.label.numberOfPeptides" width="60"/>
        <vxe-column field="statistics.numberOfGift" title="business.label.numberOfGift" width="60"/>
        <vxe-column field="statistics.numberOfOthers" title="business.label.numberOfOthers" width="60"/>
        <vxe-column field="statistics.numberOfSupervised" title="business.label.numberOfSupervised" width="60"/>
        <vxe-column field="statistics.standardCaseQuantity" title="business.label.standardCaseQuantity" width="100"/>
        <vxe-column field="statistics.volume" title="business.label.volume" width="100"/>
        <vxe-column field="statistics.weight" title="business.label.weight" width="100"/>
        <vxe-column field="statistics.amount" title="business.label.amount" width="100"/>
        <vxe-column field="order.notes" title="business.label.notes" width="200"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.detail" icon="vxe-icon-association-form" status="primary" @click.stop="goDetails(row)"/>
            <vxe-button content="button.appointLocation" icon="vxe-icon-indicator" status="primary" @click.stop="appointOrder(row)"/>
            <vxe-button content="button.oneStepOutbound" icon="vxe-icon-indicator" status="primary" @click.stop="oneStepOutbound(row)"/>
            <vxe-button content="button.orderInvert" icon="vxe-icon-undo" status="danger" @click.stop="invert(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <wave-status-modal ref="waveStatusModal"/>
  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import WaveStatusModal from '@/views/outbound/modal/WaveStatusModal'
import { ShipmentOrder } from '@/api/dto/order/ShipmentOrder'

export default {
  name: 'Arrange',
  components: { WaveStatusModal },
  data() {
    return {
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      query: new ShipmentOrder(),
      data: [],
      waves: [],
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        autoIssue: false,
        orderStatusRange: { 'start': 'INITIALIZED', 'end': 'INITIALIZED' },
        refundable: false,
        appointed: false,
        shortable: false,
        oneStep: false,
        'order.no': this.query.no
      }
      findAll('dispatchOrderListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          this.$nextTick(() => this.getWaves())
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new ShipmentOrder()
      this.refresh()
    },
    getWaves() {
      this.loading = true
      findAll('dispatchWaveSummaryFactory').then(res => {
        if (res.success) {
          this.waves = res.result.map(item => {
            return { label: item.dispatch.wave, value: item.dispatch.wave }
          })
        }
      }).finally(() => this.loading = false)
    },
    arrange() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$warning({ title: '请选择需要安排的订单', centered: true })
      }
      this.loading = true
      post(api.dispatchArrange, {}, { ids: selectedRows.map(item => item.order.id) }).then(res => {
        if (res.success) {
          this.$emit('goWaves')
        }
      }).finally(() => this.loading = false)
    },
    waveIssue() {
      this.$emit('goWaves')
    },
    goDetails(row) {
      this.$emit('goDetails', row)
    },
    appointOrder(row) {
      this.loading = true
      let order = Object.assign({}, row.order)
      order.appointed = true
      post(api.dispatchAppoint, {}, order).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    oneStepOutbound(row) {
      this.loading = true
      let order = Object.assign({}, row.order)
      order.oneStep = true
      post(api.dispatchSwitchOneStep, {}, order).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    invert(row) {
      const that = this
      this.$confirm({
        title: '是否确认整单冲红?',
        centered: true,
        onOk() {
          that.loading = true
          post(api.dispatchInvert, {}, { id: row.order.id, inverse: true }).then(res => {
            if (res.success) {
              that.refresh()
              that.$message.success(this.$t('message.operationSuccess'))
            }
          }).finally(() => that.loading = false)
        },
        onCancel() {
        }
      })
    },
    showWaveStatus() {
      this.$refs.waveStatusModal.open()
    },
    addOrderToWave() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$warning({ title: '请选择需要加入该波次的订单', centered: true })
      }
      this.loading = true
      post(api.dispatchAppend, {}, { wave: this.query.dispatch.wave, ids: selectedRows.map(item => item.order.id) }).then((res) => {
        if (res.success) {
          this.refresh()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>